import { useCallback } from "react";
import { buildParams } from "/app/src/helpers/params";
import { integrationService } from "/app/src/services";
import { useTranslation } from "react-i18next";
import { Integration } from "/app/src/models";
import { Button, useDisclosure, Modal } from "@heroui/react";
import ModalBuilder from "/app/src/components/HeroUi/helpers/ModalBuilder";

/**
 * Button to export an integration template
 */
export default function Export({ integration }: { integration: Integration }) {
  const { t } = useTranslation();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  /**
   * Function to export the integration
   * Downloads the integration template as a json file
   */
  const HandleExportClick = useCallback(() => {
    integrationService
      .exportSingle(integration.id, buildParams({ export: "json" }))
      .then((response) => {
        const data = `data:text/json;charset=utf-8,${encodeURIComponent(
          JSON.stringify(response),
        )}`;
        const link = document.createElement("a");
        link.href = data;
        link.download = `${integration.name}-template.itempath.json`;
        link.click();
      });
  }, [integration.id, integration.name]);

  const onClick = useCallback(() => {
    HandleExportClick();
    onOpenChange();
  }, [HandleExportClick, onOpenChange]);

  return (
    <div>
      <Button
        size="sm"
        radius="none"
        variant="bordered"
        color="primary"
        onPress={onOpen}
        fullWidth
        className="hover:border-primary-default hover:text-default"
      >
        {t("translation:download_template")}
      </Button>
      <Modal
        disableAnimation={false}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="top"
        aria-label="Confirm file download"
      >
        {ModalBuilder({
          modalHeader: t("translation:confirm_integration_file_download"),
          modalFooter: (
            <>
              <Button
                size="sm"
                radius="none"
                color="default"
                variant="bordered"
                onPress={onOpenChange}
              >
                {t("translation:cancel")}
              </Button>
              <Button size="sm" radius="none" color="primary" onPress={onClick}>
                {t("translation:download")}
              </Button>
            </>
          ),
        })}
      </Modal>
    </div>
  );
}
